<template>
	<div class="related-posts">
		<div class="swiper-container" ref="slider">
			<div class="navigation" v-if="actualPosts.length > 1">
				<button class="navigation__button navigation__button--prev">
					<i class="fal fa-arrow-left"></i>
				</button>
				<button class="navigation__button navigation__button--next">
					<i class="fal fa-arrow-right"></i>
				</button>
			</div>
			<div class="swiper-wrapper">
				<div
					v-for="(post, index) in actualPosts"
					:key="index"
					class="swiper-slide post"
				>
					<a :href="post.url" class="link">
						<div class="thumbnail">
							<img class="image" :src="post.image" />
							<div class="tag" v-if="getTag(post.tags)">
								{{ getTag(post.tags) }}
							</div>
						</div>
						<h4 class="title">{{ post.title }}</h4>
						<time class="time" :datetime="post.date">
							<!-- {{ dtFormatter.format(new Date(post.date)) }} -->
						</time>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Swiper from "swiper/dist/js/swiper.js";;

export default {
	name: "RelatedPosts",
	selector: '[data-vue="related-posts"]',
	props: {
		posts: {
			type: Array,
			required: true
		}
	},
	mounted() {
		this.slider = new Swiper(this.$refs.slider, {
			slidesPerView: "auto",
			spaceBetween: 28,
			loop: this.posts.actualPosts >= 3,
			// slidesOffsetAfter: 300,
			navigation: {
				nextEl: ".navigation__button--next",
				prevEl: ".navigation__button--prev",
				disabledClass: "navigation__button--disabled"
			}
		});
	},
	methods: {
		resizeImage(url) {
			return url.replace(/(\.[^\.]+)$/i, "_278x370_crop_center$1");
		},
		getTag(tags) {
			// check if a tag is prefixed with "filter-".
			// If it is, return the rest of the tag. Otherwise null
			const tag = tags.find(tag => tag.indexOf("filter-") === 0);
			if (!tag) return null;
			const [_, ...rest] = tag.split("-");
			return rest.join(" ");
		}
	},
	created() {
		this.dtFormatter = new Intl.DateTimeFormat("en-US", {
			year: "numeric",
			month: "long",
			day: "numeric"
		});
	},
	computed: {
		actualPosts() {
			return this.posts.filter(post => post);
		}
	}
};
</script>

<style lang="scss" scoped>
.post {
	width: 290px;
	&__image {
		width: 100%;
	}

	@include media("<=l-phone") {
		width: 180px;
	}

	a {
		color: $black;
		text-decoration: none;

		&:hover {
			.image {
				transform: translate(-50%, -50%) scale(1.1);
			}
		}
	}
}

.navigation {
	display: flex;
	margin-left: 50%;
	margin-bottom: 32px;

	&__button {
		@include button-reset();
	}

	&__button--next {
		margin-left: 24px;
	}
}

.title {
	font-size: 16px;
	margin: 0;
	margin-top: 24px;
  color: #001a41;
  font-weight: 500;
}

.time {
	display: block;
	margin-top: 24px;
	font-size: 11px;
}

.thumbnail {
	position: relative;
	padding-bottom: 150%;
	overflow: hidden;
}

.tag {
	position: absolute;
	top: 12px;
	right: 12px;
	background-color: #bfe4e2;
  color: #00938d;
	padding: 4px 8px;
	font-size: 14px;
  line-height: 20px;
  border-radius: 4px;
  text-transform: capitalize;
}

.image {
	position: absolute;
	width: 100%;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	transition: transform 1s ease-out;
}
</style>
